import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * Wrapped Toaster — themes the sonner surface against our brand tokens so a
 * `toast.success(...)` call from anywhere in the app reads as part of the
 * design system rather than the sonner default.
 */
const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    className="toaster group"
    toastOptions={{
      classNames: {
        toast:
          'group toast group-[.toaster]:bg-bg group-[.toaster]:text-fg group-[.toaster]:border-border group-[.toaster]:shadow-lg',
        description: 'group-[.toast]:text-fg-muted',
        actionButton:
          'group-[.toast]:bg-brand group-[.toast]:text-brand-contrast',
        cancelButton:
          'group-[.toast]:bg-bg-subtle group-[.toast]:text-fg-muted',
      },
    }}
    {...props}
  />
);

export { Toaster };
